/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateContractProposalSavingBodyInvestmentToolType =
  (typeof CreateContractProposalSavingBodyInvestmentToolType)[keyof typeof CreateContractProposalSavingBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractProposalSavingBodyInvestmentToolType = {
  saving: "saving",
} as const;
